export default {
  methods: {
    setSeo(title = '', description = '') {
      document.title = title + ' - CVweb.ru';
      if (document.querySelector('meta[name="description"]') !== null) {
        document.querySelector('meta[name="description"]').setAttribute('content', description);
      } else {
        var m = document.createElement('meta');
        m.name = 'description';
        m.content = description;
        document.head.appendChild(m);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./resources/js/mixins/seo.js